import { object, getSubscriptionStatuses } from 'common/helpers'


export const initialState = {
  id: null,

  status: null,
  // not_subscribed, active, on_hold, waiting_prolong,
  // unpaid, cancelled, pending_upgrade, pending_change_plan

  statusText: null,

  subscriptionDate: null,
  nextShippingDate: null,
  nextBillingDate: null,

  isNotSubscribed: null,
  isSubscribed: null,
  isWaitingProlong: null,
  isSkippable: null,
  isFrequencyChangeable: null,
  isCancelled: null,
  isOnHold: null,
  isUpgradable: null,
  isUpgradableForMonthlyPlan: null,
  isMonthlyPlan: null,
  isCancelable: null,
  isJustCancelled: null,
  isUnpaid: null,
  isPending: null,
  isPendingUpgrade: null,
  isPendingChangePlan: null,
  isActive: null,
  isUnpaused: null,
  isUndeliverable: null,
  unskipDate: null,

  unsubscribeFeedbackSentDate: null,

  credits: {}, // paid: 12, free: 0
  currPlan: {},
  plans: [],
  planCosts: {},

  downgradePlan: {},
  isDowngradeNeed: false,
}

export const update = (state, payload) => {
  const _state = object.mergeDeep(state, payload)

  const statuses = getSubscriptionStatuses({
    status: payload.status,
    addressStatus: payload.addressStatus,
  })

  return {
    ..._state,
    ...statuses,
  }
}

export const setCurrentPlan = (state, payload) => (
  { ...state, currPlan: payload }
)

export const setPlans = (state, payload) => (
  { ...state, plans: payload }
)

export const setPlanCosts = (state, payload) => (
  { ...state, planCosts: payload }
)

export const setUnpaused = (state, payload) => (
  { ...state, isUnpaused: payload }
)

export const setJustCancelled = (state, payload) => (
  { ...state, isJustCancelled: payload }
)

export const setDowngrade = (state, payload) => (
  { ...state, isDowngradeNeed: payload }
)

export const setDowngradePlan = (state, payload) => (
  { ...state, downgradePlan: payload }
)
